//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import TrueFalse from 'components/QuestionnaireQuestions/phoneTrueFalse.vue';
import Multiselect from 'components/QuestionnaireQuestions/phoneMultiselect.vue';
import SingleChoice from 'components/QuestionnaireQuestions/phoneSingleChoice.vue';
export default Vue.extend({
  name: 'phoneQuestionnaire',
  components: {
    Multiselect: Multiselect,
    TrueFalse: TrueFalse,
    SingleChoice: SingleChoice
  },
  data: function data() {
    return {
      activeNames: [],
      editable: false,
      praname: '第一次作业名称',
      condition: '未开始',
      changeCondition: '开始',
      quesNumber: '第一题',
      diffcult: 1,
      dialogVisible: false,
      type: '判断题',
      questionTypeName: ['单选题', '多选题', '判断题', '判断题'],
      watch: false,
      del: false,
      number: 5,
      list: [],
      dataJson: [],
      queTitle: '',
      queId: '',
      quesType: 1,
      answerType: 1,
      saveBtn: false,
      submitCount: 0,
      successCount: 0,
      submitmsg: '',
      iSubmit: false,
      questionnireName: '',
      showTitle: '',
      isShowInput: false,
      submitName: '',
      allowClick: true
    };
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    courseId: {
      type: String,
      default: ''
    }
  },
  watch: {},
  methods: {
    goDetail: function goDetail() {
      this.$router.push({
        name: "teachingDetails",
        params: {
          bookId: this.courseId
        }
      });
    },
    deleteQuestion: function deleteQuestion(index, id) {
      var _this = this;

      var that = this;
      var askMessage = '是否删除该题目?';
      var questionnaireId = '';

      if (this.list.length == 1) {
        askMessage = '删除最后一题会自动删除问卷调查哦~';
        questionnaireId = this.questionnaireId;
      }

      this.$confirm(askMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$http.post("/api/XOrg/BookMaterial/delQuestion", {
          questionId: id,
          questionnaireId: questionnaireId
        }).then(function (rst) {
          if (rst.code > 0) {
            that.list.splice(index, 1);
            that.$message({
              type: 'success',
              message: rst.msg
            });

            if (that.list.length == 0) {
              that.returnPrevPage();
            }
          } else {
            that.$message({
              type: 'warning',
              message: rst.msg
            });
          }
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addChoice: function addChoice(type) {
      var order = this.list.length + 1;
      this.list.push({
        ContentText: '',
        questionType: type,
        questionId: '',
        dataJson: [{
          Content: '',
          SortOrder: 0
        }, {
          Content: '',
          SortOrder: 1
        }, {
          Content: '',
          SortOrder: 2
        }, {
          Content: '',
          SortOrder: 3
        }],
        sortOrder: order
      });
      this.gotoTarget();
    },
    addTrueFalse: function addTrueFalse(type) {
      var order = this.list.length + 1;
      var contents = type == 3 ? ['正确', '错误'] : ['赞成', '反对'];
      this.list.push({
        ContentText: '',
        questionType: type,
        questionId: '',
        sortOrder: order,
        dataJson: [{
          Content: contents[0]
        }, {
          Content: contents[1]
        }]
      });
      this.gotoTarget();
    },
    getQuestionnaireQuesList: function getQuestionnaireQuesList() {
      var courseId = this.courseId;
      var questionnaireId = this.questionnaireId;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/getQuestionnaireStatistics", {
        courseId: 'qpxpaieqf7xjsvtx3heghw',
        questionnaireId: 'ffwrayuqjrtgzssyzfj3vq'
      }).then(function (rst) {
        that.list = rst.data;
        that.questionnireName = rst.title;
        that.allowClick = true;
      });
    },
    returnPrevPage: function returnPrevPage() {
      this.$router.go(-1);
    },
    moveUp: function moveUp(index) {
      // 上移题目
      var temp = this.list[index];
      this.list[index] = this.list[index - 1];
      this.list[index - 1] = temp;
      this.list[index - 1].sortOrder = index;
      this.list[index].sortOrder = index + 1;
      this.list.push({
        code: 1
      });
      this.list.pop();
    },
    moveDown: function moveDown(index) {
      // 下移题目
      var temp = this.list[index];
      this.list[index] = this.list[index + 1];
      this.list[index + 1] = temp;
      this.list[index + 1].sortOrder = index + 2;
      this.list[index].sortOrder = index + 1;
      this.list.push({
        code: 1
      });
      this.list.pop();
    },
    sendAllRequest: function sendAllRequest() {
      if (!this.allowClick) {
        this.$message('请不要老是点我啦~');
        return;
      }

      if (this.list.length == 0) {
        this.$message('您至少添加一题才能保存哦~');
      } else {
        // 向子页面发送提交事件的命令
        this.iSubmit = true;
        this.allowClick = false;
      }
    },
    submitChildQuestion: function submitChildQuestion(obj) {
      var that = this; // 子页面返回数据的个数

      this.submitCount = this.submitCount + obj.count; // 子页面通过数据验证的个数

      this.successCount = this.successCount + obj.code;

      if (obj.code == 0) {
        this.submitmsg = this.submitmsg + obj.msg + '<br />';
      }

      if (this.list.length == this.submitCount) {
        this.iSubmit = false;

        if (this.list.length == this.successCount) {
          var questionJson = JSON.stringify(this.list);
          this.$http.post("/api/XOrg/BookMaterial/updateQuestionnaireQuestions", {
            courseId: this.courseId,
            courseOpenId: this.openCourseId,
            questionnaireId: this.questionnaireId,
            questionnaireName: this.submitName,
            questionJson: questionJson
          }).then(function (rst) {
            if (rst.questionnaireId) {
              that.$router.push({
                name: 'questionnaire',
                params: {
                  questionnaireId: rst.questionnaireId,
                  courseId: that.courseId
                }
              }); // that.getQuestionnaireQuesList();
            } else {
              that.allowClick = true;
            }

            if (rst.code > 0) {
              that.$message(rst.msg);
            } else {
              that.$message(rst.msg);
            }
          });
        } else {
          this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: this.submitmsg
          });
          this.allowClick = true;
        }

        this.submitCount = 0;
        this.successCount = 0;
        this.submitmsg = '';
      }
    },
    gotoTarget: function gotoTarget() {
      this.$scrollTo('#target', 100, {
        offset: 500
      });
    },
    showTitleInput: function showTitleInput() {
      this.isShowInput = true;
    },
    hideTitleInput: function hideTitleInput() {
      this.isShowInput = false;
    }
  },
  created: function created() {// this.getQuestionnaireQuesList();
  }
});